import { RootState } from '../store/store';

/**
 * Check if user has a specific permission
 * @param permissions - Array of permission strings
 * @param permission - Permission to check
 * @returns boolean
 */
export const hasPermission = (
  permissions: string[] | undefined,
  permission: string
): boolean => {
  if (!permissions || permissions.length === 0) {
    return false;
  }
  return permissions.includes(permission);
};

/**
 * Check if user has any of the specified permissions
 * @param permissions - Array of permission strings
 * @param requiredPermissions - Array of permissions to check (OR logic)
 * @returns boolean
 */
export const hasAnyPermission = (
  permissions: string[] | undefined,
  requiredPermissions: string[]
): boolean => {
  if (!permissions || permissions.length === 0) {
    return false;
  }
  return requiredPermissions.some((permission) =>
    permissions.includes(permission)
  );
};

/**
 * Check if user has all of the specified permissions
 * @param permissions - Array of permission strings
 * @param requiredPermissions - Array of permissions to check (AND logic)
 * @returns boolean
 */
export const hasAllPermissions = (
  permissions: string[] | undefined,
  requiredPermissions: string[]
): boolean => {
  if (!permissions || permissions.length === 0) {
    return false;
  }
  return requiredPermissions.every((permission) =>
    permissions.includes(permission)
  );
};

/**
 * Get user permissions from Redux state
 * @param state - Redux state
 * @returns Array of permission strings or empty array
 */
export const getUserPermissions = (state: RootState): string[] => {
  return state.auth.user?.permissions || [];
};

